<template>
  <component :is="iconComponent" :fill="fill" />
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';
import NCalendarIcon from '../../../icons/calendar-icon.vue';
import NCustomAttributeIcon from '../../../icons/custom-attribute-icon.vue';
import NDecimalIcon from '../../../icons/decimal-icon.vue';
import NEmailIcon from '../../../icons/email-icon.vue';
import NNumberIcon from '../../../icons/number-icon.vue';
import NPageIcon from '../../../icons/page-icon.vue';
import NPersonIcon from '../../../icons/person-icon.vue';
import NPhoneIcon from '../../../icons/phone-icon.vue';
import NQuestionIcon from '../../../icons/question-icon.vue';
import NShortTextIcon from '../../../icons/text-icon.vue';
import NChevronRightIcon from '../../../icons/chevron-right-icon.vue';
import NChevronLeftIcon from '../../../icons/chevron-left-icon.vue';
import NSkipNextIcon from '../../../icons/skip-next-icon.vue';
import NSkipPreviousIcon from '../../../icons/skip-previous-icon.vue';
import NAddIcon from '../../../icons/add-icon.vue';
import NRefreshIcon from '../../../icons/refresh-icon.vue';
import NConversationRefreshIcon from '../../../icons/conversation-refresh-icon.vue';
import NTickIcon from '../../../icons/tick-icon.vue';
import NAlertIcon from '../../../icons/alert-icon.vue';
import NSendIcon from '../../../icons/send-icon.vue';
import NEmojiIcon from '../../../icons/emoji-icon.vue';
import NCopyIcon from '../../../icons/copy-icon.vue';
import NDeleteIcon from '../../../icons/delete-icon.vue';
import NFileIcon from '../../../icons/file-icon.vue';

const iconMap = {
  add: NAddIcon,
  calendar: NCalendarIcon,
  copy: NCopyIcon,
  'custom-attribute': NCustomAttributeIcon,
  decimal: NDecimalIcon,
  email: NEmailIcon,
  number: NNumberIcon,
  page: NPageIcon,
  person: NPersonIcon,
  phone: NPhoneIcon,
  question: NQuestionIcon,
  'short-text': NShortTextIcon,
  'chevron-right': NChevronRightIcon,
  'chevron-left': NChevronLeftIcon,
  'skip-next': NSkipNextIcon,
  'skip-previous': NSkipPreviousIcon,
  refresh: NRefreshIcon,
  'conversation-refresh': NConversationRefreshIcon,
  tick: NTickIcon,
  alert: NAlertIcon,
  send: NSendIcon,
  emoji: NEmojiIcon,
  delete: NDeleteIcon,
  file: NFileIcon,
};

export type IconType = keyof typeof iconMap;

defineOptions({
  name: 'n-icon',
});

const props = defineProps({
  icon: {
    type: String as PropType<IconType>,
    required: true,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});

const iconComponent = computed(() => iconMap[props.icon]);
</script>

<style lang="scss" scoped>
.n-icon {
  height: 1em;
  width: 1em;
  display: inline-block;
  :deep(svg) {
    height: 100%;
    width: 100%;
  }
}
</style>
